import Toastify from 'toastify-js'
import React from 'react'
const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const camelize = (string) => {
  return string.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
}

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US',
    { year: 'numeric', month: 'long', day: 'numeric' })
}

const formatTime = (date) => {
  return new Date(date).toLocaleTimeString('en-US',
    { hour: 'numeric', minute: 'numeric', hour12: true })
}

const formatDateTime = (date) => {
  return formatDate(date) + ' ' + formatTime(date)
}

const copyToClipboard = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
  } else {
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
  }
}

const highlightMatches = (text, query) => {
  if (!query || query.length < 4) return text;
  
  // Escape special regex characters from query
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) => {
    // Check if odd index (matches) and part is not empty
    if (index % 2 === 1 && part !== '') {
      return <span key={index} className="bg-yellow-600 dark:bg-yellow-600">{part}</span>;
    }
    return part;
  });
};

const toast = ({message, type = 'success', duration = 3000, gravity = 'top', position = 'right', close = true}) => {
  Toastify({
    text: message,
    duration: duration,
    gravity: gravity,
    position: position,
    close: close,
    style: {
      background: type === 'success' ? 'green' : 'red',
    }
  }).showToast()
}
export { capitalize, camelize, formatDate, formatTime, formatDateTime, copyToClipboard, toast, highlightMatches }